import { render, staticRenderFns } from "./majorList.vue?vue&type=template&id=4779e130&scoped=true&"
import script from "./majorList.vue?vue&type=script&lang=js&"
export * from "./majorList.vue?vue&type=script&lang=js&"
import style0 from "./majorList.vue?vue&type=style&index=0&id=4779e130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4779e130",
  null
  
)

export default component.exports